import PropTypes from 'prop-types';
import { useLayoutEffect, useRef, useState } from 'react';
import { Area, Conteudo } from './styled';

/**
 * Area que abre e fecha animando a altura real do conteudo.
 *
 * O alvo do max-height e medido, nao chutado: um valor fixo alto faz a
 * animacao terminar antes do tempo e um valor baixo corta o conteudo. O
 * ResizeObserver mantem a medida em dia quando o conteudo muda de altura sem
 * remontar — um campo que aparece dentro do formulario, por exemplo.
 *
 * O conteudo continua montado com a area fechada: quem digitou algo e fechou
 * sem querer nao perde o que escreveu.
 *
 * @param aberto - estado atual
 * @param vao - gap do container pai, para compensar o espaco da area fechada
 * @param children - conteudo colapsavel
 */
export default function AreaColapsavel({ aberto, vao = '0px', children }) {
  const refConteudo = useRef(null);
  const [altura, setAltura] = useState(0);

  useLayoutEffect(() => {
    const el = refConteudo.current;
    if (!el) {
      return;
    }
    const medir = () => setAltura(el.scrollHeight);
    medir();
    if (typeof ResizeObserver === 'undefined') {
      return;
    }
    const observer = new ResizeObserver(medir);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Area
      $aberto={aberto}
      $vao={vao}
      style={{ maxHeight: aberto ? `${altura}px` : 0 }}
    >
      <Conteudo ref={refConteudo}>{children}</Conteudo>
    </Area>
  );
}

AreaColapsavel.propTypes = {
  aberto: PropTypes.bool,
  vao: PropTypes.string,
};
